module.exports = __webpack_public_path__ + "string.2df20681f5fcc0fcfef898bab663135f.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/getting-started/animation/string.svg
// module id = 1397572405368558
// module chunks = 1